export default "__VITE_ASSET__DXFazk1t__"